var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 548,
    viewBox: "0 0 115 548",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49999 506.5L112.5 547.5L112.5 519L90.5 511.5L90.5 472.5L112.5 465L112.5 435.5L3.49999 477L3.49999 506.5Z",
    stroke: "url(#paint0_linear_1561_1849)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.5 422.5L3.49999 422.5L3.49999 382C2.33332 369.333 6.19999 344 31 344C43.4 344 50.8333 354.333 53 359.5C54.6667 352.833 62.4 339.5 80 339.5C106 339.5 112.5 365.833 112.5 379L112.5 422.5Z",
    stroke: "url(#paint1_linear_1561_1849)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.999988 269C0.999989 299 22 327 57.5 327C93 327 114 300 114 269C114 238 92.5 212 57.5 212C22.5 212 0.999987 239 0.999988 269Z",
    stroke: "url(#paint2_linear_1561_1849)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49998 167.5L3.49998 193L69 193C84 193.5 114 184.9 114 146.5C114 108.1 84 99.5 69 100L3.49998 100L3.49998 126L69 126C76.1666 125.333 90.5 128.5 90.5 146.5C90.5 164.5 76.1666 168 69 167.5L3.49998 167.5Z",
    stroke: "url(#paint3_linear_1561_1849)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27 85L3.49998 85L3.49998 1L27 0.999999L27 30L112 30L112 56L27 56L27 85Z",
    stroke: "url(#paint4_linear_1561_1849)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25 269C25 287 38 300 57.5 300C78 300 90.5 287.5 90.5 269C90.5 250.5 77 238 57.5 238C38 238 25 251 25 269Z",
    stroke: "url(#paint5_linear_1561_1849)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48 396.5L22.5 396.5L22.5 384.5C22 379.333 23.7 369 34.5 369C45.3 369 48 377.667 48 382L48 396.5Z",
    stroke: "url(#paint6_linear_1561_1849)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93 396.5L66 396.5L66 379C66 374.667 68.8 366 80 366C91.2 366 93.3333 375.667 93 380.5L93 396.5Z",
    stroke: "url(#paint7_linear_1561_1849)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31 492L68 505L68 478.5L31 492Z",
    stroke: "url(#paint8_linear_1561_1849)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1561_1849",
    x1: 114,
    y1: 441,
    x2: 19.1287,
    y2: 45.7732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1561_1849",
    x1: 114,
    y1: 441,
    x2: 19.1287,
    y2: 45.7732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1561_1849",
    x1: 114,
    y1: 441,
    x2: 19.1287,
    y2: 45.7732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1561_1849",
    x1: 114,
    y1: 441,
    x2: 19.1287,
    y2: 45.7732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1561_1849",
    x1: 114,
    y1: 441,
    x2: 19.1287,
    y2: 45.7732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1561_1849",
    x1: 114,
    y1: 441,
    x2: 19.1288,
    y2: 45.7732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1561_1849",
    x1: 114,
    y1: 441,
    x2: 19.1287,
    y2: 45.7731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1561_1849",
    x1: 114,
    y1: 441,
    x2: 19.1287,
    y2: 45.7731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1561_1849",
    x1: 114,
    y1: 441,
    x2: 19.1287,
    y2: 45.7732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.16c6921213f89ffb7b6b15a107485bcf.svg";
export { ForwardRef as ReactComponent };